export default __webpack_public_path__ + "static/media/warning--trail-crossing--g4.07b92d0e.png";